import { BONUSX_CMS_TOKEN, BONUSX_CMS_URL } from "../../constants/env";

const CMS_REQUEST_TIMEOUT_MILLISECONDS = 30000;

export function getBonusxCmsConfig() {
  return {
    baseURL: BONUSX_CMS_URL || "",
    headers: { Authorization: `Bearer ${BONUSX_CMS_TOKEN}` },
    timeout: CMS_REQUEST_TIMEOUT_MILLISECONDS,
  };
}
